




























































import { Component, Vue, Prop } from 'vue-property-decorator';

import { IBusinessType } from '@/models/business';
import { EProgramStatusStatus } from '@/models/program-status';
import { StartGuideCardActiveProgram } from '@/models/start-guide';

import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import Loading from '@/components/icons/Loading.vue';
import InStore from '@/components/icons/InStore.vue';
import Online from '@/components/icons/OnlineStore.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import ProgramStatusTag from '@/componentsV2/atoms/ProgramStatusTag/ProgramStatusTag.vue';
import flagKeys from '@/constants/flagKeys';

export type TProgramStatusData = {
  operationType: IBusinessType;
};

@Component({
  components: {
    FilterTag,
    Loading,
    InStore,
    Online,
    CoinsIcon,
    Typography,
    ProgramStatusTag
  }
})
export default class BoxProgramStatus extends Vue {
  @Prop() programStatus!: TProgramStatusData;

  get isRewardBoth() {
    return this.programStatus.operationType === IBusinessType.BOTH;
  }

  get isInStore() {
    return this.programStatus.operationType === IBusinessType.INSTORE;
  }

  get isOnline() {
    return this.programStatus.operationType === IBusinessType.ONLINE;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isDashboardSellCoinsAndLoyaltVerify() {
    return this.flags.includes(flagKeys.dashboardSellCoinsAndLoyaltVerify);
  }

  get isSellingCoins() {
    const sellCoinsProgram = this.activePrograms.find(
      program => program.slug === 'sell-coins'
    );

    return sellCoinsProgram || false;
  }

  get activePrograms() {
    return this.$store.getters[
      'startGuide/getActivePrograms'
    ] as StartGuideCardActiveProgram[];
  }

  get rewardsProgramStatus() {
    const rewardCoinsProgram = this.activePrograms.find(
      program => program.slug === 'reward-coins'
    );

    if (!rewardCoinsProgram) return 'Active';

    return rewardCoinsProgram.label || 'Active';
  }

  get actualProgramStatus() {
    if (this.isRewardBoth) return EProgramStatusStatus.PARTIALLY_ACTIVE;

    if (this.isOnline) return EProgramStatusStatus.ACTIVE;

    const rewardStatus = this.$store.getters['business/getRewardStatus'];

    if (rewardStatus && rewardStatus.rewardStatus !== 'inactive') {
      return this.$store.getters['business/getRewardStatus'].rewardStatus;
    } else {
      return EProgramStatusStatus.PENDING;
    }
  }
}
